import React, { Component } from 'react'

import SmoothCollapse from 'react-smooth-collapse'
import Icon from 'components/icon/icon'
import DayPicker from 'react-day-picker'
import moment from 'moment'

import {
    doClickEventListeners
} from 'utils'

class DateContainer extends Component {

	UNSAFE_componentWillMount(){
		doClickEventListeners(this.handleClick)
	}

	componentWillUnmount(){
		doClickEventListeners(this.handleClick,true)
    }

	handleClick = e => {
		if(this.props.closeCallback && this.props.isOpen && !this.ref.contains(e.target)){
            this.props.closeCallback()
		}
	}
    
    render (){
        const {
            isEdit,
            isOpen,
            toggleCallback,
            selectCallback,
            initialMonth,
            selectedDate,
            label,
            allowPast,
            disabled,
            showTodayInLabel
        } = this.props

        let containerClassName = 'dates-container clear'

        if(disabled){
            containerClassName += ' disabled'
        }

        const isToday = selectedDate && moment(selectedDate).isSame(moment(), 'day')

        return (
            <div className={containerClassName} ref={ref => this.ref = ref}>
                { isEdit ?
                <div 
                    className={isOpen ? 'button-proxy active' : 'button-proxy'} 
                    onClick={toggleCallback}
                >
                    <Icon name="fe-calendar" />
                    { selectedDate ?
                        moment(selectedDate).format('MMMM Do')+(showTodayInLabel && isToday ? ' (Today)' : '') :
                        label ? label : 'Event date'
                    }
                    <Icon name="caret-down" />
                    <div 
                        onClick={e => {e.stopPropagation()}}
                        className="modal-datepicker"
                    >
                        <SmoothCollapse 
                            allowOverflowWhenOpen={true} 
                            expanded={isOpen}
                            heightTransition="0.15s ease"
                        >
                            <DayPicker 
                                onDayClick={day => {selectCallback(day)}} 
                                selectedDays={new Date(selectedDate)} 
                                initialMonth={initialMonth} 
                                firstDayOfWeek={1}
                                disabledDays={{
                                    before: allowPast ? null : new Date()
                                }}
                            />
                        </SmoothCollapse>
                    </div>
                </div>
                :
                <span>
                    { moment(selectedDate).format('MMMM Do') }
                </span>
                }
            </div>
        )
    }
}

export default DateContainer